import React, { useEffect } from "react";
import Footer from "../../components/Footer";

const Calendar = () => {
  useEffect(() => {
    // Load external script
    const script = document.createElement("script");
    script.src = "https://link.msgsndr.com/js/form_embed.js";
    script.type = "text/javascript";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          // Top-aligned: the embed script grows the iframe past the viewport,
          // and centring would push its top up under the fixed navbar.
          alignItems: "flex-start",
        }}
      >
        <iframe
          src="https://api.leadconnectorhq.com/widget/booking/S3E9EMBuSZJyrieail0P"
          style={{
            width: "90%",
            height: "80vh",
            minHeight: "700px",
            border: "none",
            overflow: "auto",
          }}
          scrolling="yes"
          id="3667Tctq8mtAdKDet53h_1743610207175"
          title="Booking Calendar"
        />
      </div>
      <Footer />
    </>
  );
};

export default Calendar;
